import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import Layout from '../../components/Layout/Layout';
import { ShowFinish } from '../../components';
import { getQuizShow } from '../../actions/test';
import { LoadSpinner } from '../../components/Utils';

class QuizShow extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    const { dispatch, match } = this.props;
    dispatch(getQuizShow(match.params.id));
  }

  render() {
    const { quiz, ongoingRequest } = this.props;
    return (
      <Layout>
        <Container fluid>
          {!quiz.id ? (
            <Row>
              <LoadSpinner />
            </Row>
          ) : (
            <Row>
              <Col role="main">
                <div className="section">
                  <ShowFinish quiz={quiz} ongoingRequest={ongoingRequest} />
                </div>
              </Col>
            </Row>
          )}
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const {
    ongoingRequest,
    quiz: { quiz }
  } = state.test;
  return {
    ongoingRequest,
    quiz
  };
};

export default connect(mapStateToProps)(QuizShow);
